export const formatCreditCardNumber = (cardNumber: string, isDefault = false) => {
  const cleanedCardNumber = cardNumber.replace(/-/g, '').replace(/X/g, '*');
  const defaultText = isDefault ? ' (Default)' : '';
  return `Card ${cleanedCardNumber}${defaultText}`;
};
